import {FillObjectStrategy} from "../../../../_types/FillObjectStrategy";
import {PatternFillOptions} from "../../../../_types/PatternFillOptions";
import {Point} from "../../../../_types/Point";
import {Size} from "../../../../_types/Size";


export class PatternFillObjectStrategy implements FillObjectStrategy {

    constructor(private options: PatternFillOptions) {}
    // eslint-disable-next-line prefer-arrow/prefer-arrow-functions
    getPosition(index: number, sceneSize: Size): Point {

        const { options } = this;

        const diagonal = Math.sqrt(Math.pow(sceneSize.width, 2) + Math.pow(sceneSize.height, 2));

        const spacing = {x: options.spacing.x * diagonal, y: options.spacing.y * diagonal};

        const patternCellWidth = options.width * spacing.x;
        const patternCellHeight = options.height * spacing.y;

        const drawOffset = {
            x: Math.abs(((sceneSize.width / 2) % patternCellWidth) - patternCellWidth),
            y: Math.abs(((sceneSize.height / 2) % patternCellHeight) - patternCellHeight)
        };

        const columns = Math.ceil((sceneSize.width + drawOffset.x * 2) / patternCellWidth) + 1;

        const patternPointIndex = index % options.pattern.length;
        const patternPoint = options.pattern[patternPointIndex];

        const column = Math.floor(index / options.pattern.length) % columns;
        const row = Math.floor(Math.floor(index / options.pattern.length) / columns);

        return {
            x: patternPoint.x * spacing.x - drawOffset.x + column * patternCellWidth,
            y: patternPoint.y * spacing.y - drawOffset.y + row * patternCellHeight
        };
    }
}